var _path, _path2, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513.62 289.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "outline",
    d: "m267.7,289.89H22.18c-12.23,0-22.18-9.95-22.18-22.18V22.18C0,9.95,9.95,0,22.18,0h245.52c12.23,0,22.19,9.95,22.19,22.18v245.52c0,12.23-9.95,22.18-22.19,22.18Z",
    preserveAspectRatio: "xMidYMid meet"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "fill",
    d: "m22.18,10.46h245.52c6.47,0,11.72,5.25,11.72,11.72v245.52c0,6.47-5.25,11.72-11.72,11.72H22.19c-6.47,0-11.72-5.25-11.72-11.72V22.18c0-6.47,5.25-11.72,11.72-11.72Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clt"
  }, /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "m167.41,210.55l1.39.75c2.37,1.27,2.94,4.42,1.17,6.45-5.42,6.24-13.31,10.24-22.68,10.24-17.5,0-30.43-13.73-30.43-30.43s12.93-30.43,30.43-30.43c9.37,0,17.25,3.99,22.67,10.17,1.77,2.01,1.22,5.15-1.12,6.44l-1.45.8c-1.73.95-3.93.63-5.21-.87-3.56-4.16-8.79-6.7-14.89-6.7-11.44,0-19.79,8.69-19.79,20.59s8.35,20.48,19.79,20.48c6.1,0,11.33-2.46,14.89-6.59,1.29-1.5,3.49-1.83,5.24-.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "l",
    d: "m195.45,150.62v71.7c0,2.31-1.87,4.19-4.19,4.19h-2.04c-2.31,0-4.19-1.87-4.19-4.19v-71.7c0-2.31,1.87-4.19,4.19-4.19h2.04c2.31,0,4.19,1.87,4.19,4.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "t",
    d: "m228.05,178.46v25.39c0,8.24.11,13.73,9.15,13.73.02,0,.03,0,.05,0,2.3,0,4.18,1.83,4.18,4.14v1.13c0,2.24-1.76,4.07-4,4.18-.51.03-1.04.04-1.61.04-12.58,0-18.19-6.75-18.19-19.45v-29.17h-4.85c-2.31,0-4.19-1.87-4.19-4.19v-1.58c0-2.31,1.87-4.19,4.19-4.19h4.85v-7.94c0-2.31,1.87-4.19,4.19-4.19h2.04c2.31,0,4.19,1.87,4.19,4.19v7.94h9.2c2.31,0,4.19,1.87,4.19,4.19v1.58c0,2.31-1.87,4.19-4.19,4.19h-9.2Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "dev"
  }, /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "m379.76,145.23v82.71h-19.14v-5.79c-3.54,4.25-8.86,7.32-16.9,7.32-18.67,0-28.71-15.71-28.71-31.43s10.04-31.43,28.71-31.43c8.03,0,13.35,3.07,16.9,7.33v-28.71h19.14Zm-19.73,52.81c0-8.03-5.67-12.88-12.88-12.88-7.92,0-12.76,5.44-12.76,12.88s4.84,12.76,12.76,12.76c7.21,0,12.88-4.84,12.88-12.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "m448.76,203.83h-43.24c2.01,6.97,7.68,10.16,15.01,10.16,6.14,0,10.4-2.95,12.29-5.2l13.47,8.03c-4.84,7.44-14.06,12.64-25.76,12.64-20.2,0-33.67-12.76-33.67-31.43s13.82-31.43,30.96-31.43,33.32,12.05,30.96,37.22Zm-17.37-11.58c-1.42-6.97-6.38-10.16-13-10.16-6.03,0-11.11,3.54-12.88,10.16h25.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "v",
    d: "m513.62,168.03l-23.28,59.9h-18.55l-23.28-59.9h20.44l12.17,38.28,12.17-38.28h20.32Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.75a41695b2e04ecb20278edd9fd148cb.svg";
export { ForwardRef as ReactComponent };